export const CLIENT_GROUP_PRODUCT_PRICE_SUGGESTION_TABLE =
  "clientGroupProductPriceSuggestions"
export const CLIENT_GROUP_PRODUCT_PRICE_SUGGESTION_TABLE_SCHEMA =
  "id, companyId, targetId, syncId"
